/** @format */

import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import '../css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
	const file_name = 'polity-privacy.md';
	const [markdown, setMarkdown] = useState('');

	useEffect(() => {
		import(`../utils/${file_name}`)
			.then((res) => {
				fetch(res.default)
					.then((res) => res.text())
					.then((text) => {
						setMarkdown(text);
					});
			})
			.catch((err) => {
				console.log(err);
			});
	});

	return (
		<div className='privacy'>
			<div className='privacy-container container padding'>
				{/* <ReactMarkdown children={PrivacyMarkdown} remarkPlugins={[gfm]} /> */}
				<Markdown>{markdown}</Markdown>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
